import { ReactNode, useRef } from 'react'
import { Card, Popper } from '@mui/material'
import { animated, useSpring } from '@react-spring/web'

type TooltipCardProps = {
  children: ReactNode
}

// Workaround so that the tooltip doesn't cause the page to overflow
export default function TooltipCard({ children }: TooltipCardProps) {
  const nodeRef = useRef<HTMLDivElement>(null)
  const style = useSpring({
    to: {
      opacity: 1,
    },
    from: {
      opacity: 0,
    },
    config: {
      clamp: true,
      tension: 500,
    },
    delay: 50,
  })

  return (
    <>
      <div
        ref={nodeRef}
        // This is a workaround so that the tooltip shows up for bar charts [sc-15596]
        style={{ visibility: 'hidden', height: '1px' }}
      >
        /
      </div>
      {nodeRef.current && (
        <Popper anchorEl={nodeRef.current} disablePortal open placement="top">
          {/* @ts-expect-error -- It does actually accept children */}
          <animated.div style={style}>
            <Card sx={{ transform: 'translateY(2px)' }}>{children}</Card>
          </animated.div>
        </Popper>
      )}
    </>
  )
}
